var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#CopyIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92 1.92c.11-.108.259-.17.413-.17h5.25a.583.583 0 0 1 .584.583v.584a.583.583 0 1 0 1.166 0v-.584a1.75 1.75 0 0 0-1.75-1.75h-5.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h.584a.583.583 0 1 0 0-1.166h-.584a.583.583 0 0 1-.583-.584v-5.25c0-.154.061-.303.17-.412"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.417 4.667a1.75 1.75 0 0 0-1.75 1.75v5.25c0 .966.783 1.75 1.75 1.75h5.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75zm-.584 1.75c0-.322.261-.584.584-.584h5.25c.322 0 .583.262.583.584v5.25a.583.583 0 0 1-.583.583h-5.25a.583.583 0 0 1-.584-.583z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CopyIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgCopyIcon;